import { IconBase, type IconProps } from './iconBase';

import type { JSX } from 'react';

export const Auto = ({ type, ...rest }: IconProps): JSX.Element => (
  <IconBase viewBox='0 0 24 24' {...rest}>
    {type === 'stroke' ? (
      <>
        <rect
          x='2.75'
          y='2.75'
          width='18.5'
          height='18.5'
          rx='3.25'
          stroke='currentColor'
          strokeWidth='1.5'
        />
        <path
          d='M11.9934 7C12.2652 7.00007 12.504 7.07422 12.7102 7.22168C12.9165 7.35999 13.09 7.58592 13.2307 7.89941L16.8606 15.6582C16.9824 15.9071 17.024 16.1376 16.9866 16.3496C16.9584 16.5525 16.8647 16.7141 16.7053 16.834C16.5459 16.9446 16.3393 17 16.0862 17C15.7675 16.9999 15.5192 16.9258 15.3411 16.7783C15.1723 16.6308 15.0221 16.4003 14.8909 16.0869L14.3079 14.7598H9.66821L9.09497 16.0869C8.9543 16.4096 8.8042 16.6454 8.64478 16.793C8.49475 16.931 8.26976 17 7.96997 17C7.70739 17 7.49131 16.9402 7.32251 16.8203C7.16314 16.7004 7.05982 16.5388 7.01294 16.3359C6.9755 16.1331 7.01802 15.9071 7.13989 15.6582L10.7415 7.89941C10.8915 7.58598 11.0694 7.36 11.2756 7.22168C11.482 7.07415 11.7214 7 11.9934 7ZM10.3948 13.0859H13.5764L11.9934 9.40625H11.9651L10.3948 13.0859Z'
          fill='currentColor'
        />
      </>
    ) : (
      <path
        d='M18 2C20.2091 2 22 3.79086 22 6V18C22 20.2091 20.2091 22 18 22H6C3.79086 22 2 20.2091 2 18V6C2 3.79086 3.79086 2 6 2H18ZM11.9932 7C11.7212 7 11.4817 7.07415 11.2754 7.22168C11.0692 7.36001 10.8912 7.58605 10.7412 7.89941L7.13965 15.6582C7.01775 15.9071 6.97619 16.1331 7.01367 16.3359C7.06054 16.5387 7.16297 16.7005 7.32227 16.8203C7.49105 16.9402 7.70717 17 7.96973 17C8.2695 17 8.49448 16.931 8.64453 16.793C8.80396 16.6454 8.95406 16.4096 9.09473 16.0869L9.66797 14.7598H14.3076L14.8906 16.0869C15.0219 16.4003 15.1721 16.6308 15.3408 16.7783C15.519 16.9259 15.7681 17 16.0869 17C16.3398 16.9999 16.5458 16.9445 16.7051 16.834C16.8645 16.7141 16.9582 16.5525 16.9863 16.3496C17.0238 16.1376 16.9822 15.9071 16.8604 15.6582L13.2305 7.89941C13.0898 7.58591 12.9163 7.35999 12.71 7.22168C12.5037 7.07423 12.265 7.00004 11.9932 7ZM11.9932 9.40625L13.5762 13.0859H10.3945L11.9648 9.40625H11.9932Z'
        fill='currentColor'
      />
    )}
  </IconBase>
);
